import { render, staticRenderFns } from "./HighlightedService.vue?vue&type=template&id=0ede2698&scoped=true"
import script from "./HighlightedService.vue?vue&type=script&lang=ts"
export * from "./HighlightedService.vue?vue&type=script&lang=ts"
import style0 from "./HighlightedService.vue?vue&type=style&index=0&id=0ede2698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede2698",
  null
  
)

export default component.exports